import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Button, DialogContent, DialogTitle, Typography } from '@mui/material';
import { MutationOptions } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  EndInvoiceRemindingMutation,
  EndInvoiceRemindingMutationVariables,
  useEndInvoiceRemindingMutation,
} from '../../../api/gql';
import { notify } from '../../../utils/notification';

type Props = {
  invoiceId: string;
  transNs?: string;
  keyPrefix?: string;
  onSuccess?: MutationOptions<EndInvoiceRemindingMutation, any, EndInvoiceRemindingMutationVariables>['onSuccess'];
};

export const EndRemindingModule = ({ invoiceId, transNs, keyPrefix, onSuccess }: Props) => {
  const { t } = useTranslation(transNs, { keyPrefix });

  const { mutate, isPending: isMutating } = useEndInvoiceRemindingMutation({
    onSuccess: (res, variables, context) => {
      notify.positive({ message: t('notification.success') });
      onSuccess?.(res, variables, context);
    },
    onError: (e) => {
      console.error(e);
      notify.negative({ message: t('notification.error') });
    },
  });

  const onSubmit = () => {
    if (!invoiceId) {
      throw new Error('Unexpected - route variable :invoiceId is missing.');
    }

    mutate({
      invoiceId: invoiceId,
    });
  };

  return (
    <>
      <DialogTitle>{t('title')}</DialogTitle>
      <DialogContent dividers sx={{ position: 'relative' }}>
        <Typography whiteSpace={'break-spaces'}>{t('contentText')}</Typography>

        <Box mt={4} display={'flex'} flexDirection={'column'} gap={2}>
          <LoadingButton loading={isMutating} variant={'contained'} size={'large'} onClick={onSubmit}>
            {t('action.submit')}
          </LoadingButton>
          <Button component={Link} to={'..'}>
            {t('action.cancel')}
          </Button>
        </Box>
      </DialogContent>
    </>
  );
};
